const handleCookieConsentChange = e => {
  e.preventDefault();
  Cookiebot.renew();
};

const removeVideoPlaceholder = (videoCookieConsentElement, videoElement) => {
  videoCookieConsentElement.setAttribute('aria-hidden', 'true');
  const playButton = videoElement.querySelector('.js-video-play');
  playButton ? playButton.classList.remove('d-none') : null;
};

const addVideoPlaceholder = (videoCookieConsentElement, videoPlayer) => {
  videoCookieConsentElement.setAttribute('aria-hidden', 'false');

  const parentDiv = videoCookieConsentElement.closest('.js-c-video');
  const videoPlayerDiv = document.createElement('div');

  videoPlayerDiv.classList.add('js-video-player');
  parentDiv.insertBefore(videoPlayerDiv, videoCookieConsentElement);
  videoPlayer.remove();
};

export const videoCookieHandler = element => {
  const cookieConsentElement = element.querySelector(
    '.js-video-cookie-consent',
  );
  if (cookieConsentElement) {
    cookieConsentElement.setAttribute('aria-hidden', 'false');
  }
};

const init = () => {
  const cookieconsentChangeBtns = document.querySelectorAll(
    '.js-cookie-concent-change',
  );
  if (cookieconsentChangeBtns.length) {
    cookieconsentChangeBtns.forEach(btn => {
      btn.addEventListener('click', handleCookieConsentChange);
    });
  }

  const videoCookieConsentElements = document.querySelectorAll(
    '.js-video-cookie-consent',
  );

  window.addEventListener('CookiebotOnConsentReady', function () {
    if (videoCookieConsentElements.length) {
      videoCookieConsentElements.forEach(videoCookieConsentElement => {
        const videoElement = videoCookieConsentElement.closest('.js-c-video ');
        const videoPlayer = videoElement.querySelector('.js-video-player');
        if (
          Cookiebot.consent.marketing &&
          videoCookieConsentElement.getAttribute('aria-hidden') == 'false'
        ) {
          removeVideoPlaceholder(videoCookieConsentElement, videoElement);
        } else if (
          !Cookiebot.consent.marketing &&
          videoCookieConsentElement.getAttribute('aria-hidden') == 'true' &&
          videoPlayer.nodeName == 'IFRAME'
        ) {
          addVideoPlaceholder(videoCookieConsentElement, videoPlayer);
        }
      });
    }
  });
};

const cookiebot = {
  init,
};

export default cookiebot;
